export default __webpack_public_path__ + "static/media/projects.2b352a52.svg";